import { profileError, resetProfileFlagChange } from "./reducer";

/**
 * Edición de perfil: pendiente de conectar con API v1 (p. ej. PATCH /me).
 */
export const editProfile = (_user) => async (dispatch) => {
  dispatch(
    profileError("La edición de perfil no está conectada a la API v1 todavía.")
  );
};

export const resetProfileFlag = () => resetProfileFlagChange();
